// MarkdownRenderer.js
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

const MarkdownRenderer = ({ content }) => {

  const tableStyles = {
    table: {
      borderCollapse: 'collapse',
      width: '100%',
      margin: '1rem 0',
    },
    th: {
      border: '1px solid #ddd',
      padding: '8px',
      backgroundColor: '#f4f4f4',
    },
    td: {
      border: '1px solid #ddd',
      padding: '8px',
    },
    left: {
      textAlign: 'left',
    },
    center: {
      textAlign: 'center',
    },
    right: {
      textAlign: 'right',
    }
  };

  return (
    <ReactMarkdown
      children={content}
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkGfm]}
      components={{
        table: ({node, ...props}) => (
          <table style={tableStyles.table} {...props} />
        ),
        th: ({node, style, align, ...props}) => (
          <th 
            style={{
              ...tableStyles.th,
              ...(align === 'left' && tableStyles.left),
              ...(align === 'center' && tableStyles.center),
              ...(align === 'right' && tableStyles.right),
            }} 
            {...props}
          />
        ),
        td: ({node, style, align, ...props}) => (
          <td 
            style={{
              ...tableStyles.td,
              ...(align === 'left' && tableStyles.left),
              ...(align === 'center' && tableStyles.center),
              ...(align === 'right' && tableStyles.right),
            }} 
            {...props}
          />
        ),
      }}
    />
  );
};

export default MarkdownRenderer;